import { Heading, Stack, Text as ChakraText,
Divider } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from '../../../ui-kit'
import { BaseLayout } from '..'
import UserDetails from '../../components/Profile/UserDetails'
import { MainContentHeadingBox } from '../Base/MainContent'

const codeBlockStyles = {
  backgroundColor: '#193055',
  padding: 30,
  lineHeight: '20px',
  fontSize: 14,
  marginRight: '40px',
}

const UserProfileLayout = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <BaseLayout>
      <MainContentHeadingBox>
        <Stack direction={['column']} spacing={1}>
          <Heading
            as="h5"
            size="md"
            fontWeight="600"
            color={colors.appDarkIndigo}
          >
            {t('profile', 'Profile')}
          </Heading>
          <ChakraText>
            {t(
              'profile_page_subheading',
              'Invoice will be created with the following details',
            )}
          </ChakraText>
        </Stack>
      </MainContentHeadingBox>
      <UserDetails />
    </BaseLayout>
  )
}

export default UserProfileLayout
